import { API_RESOURCE } from '@/constants/api.constant'
import { axios } from '@/lib/axios'
import CrudService from '@/services/crudService'

class UserManualService extends CrudService {
  constructor() {
    super(API_RESOURCE.USER_MANUAL)
  }

  fetchUserManualByType = async (type) => {
    const response = await axios.get(`${this.resource}/type/${type}`)

    return response.data
  }
}

export default UserManualService
